import React, { Component } from 'react';
import '../../../stylesheets/document.scss'
import BootstrapTable from 'react-bootstrap-table-next';
import { changePath } from '../../../utils/common';

const WS = String.raw`
var _req = '{"task":"cn","channel":"","token":"' + FEED_TOKEN + '","user": "' + CLIENT_CODE + '","acctid":"' + CLIENT_CODE + '"}'; 

websocketObj.send(_req); 

 
 

// socket_scripts = “EXCHANGE|token” FOR MULTI STOCKS use & to separate them. EX: “nse_cm|2885&nse_cm|1594&nse_cm|11536" OR "nse_cm|236"

var strwatchlistscrips = "nse_cm|2885&nse_cm|1594&nse_cm|11536";

var _req = '{"task":"mw","channel":"' + strwatchlistscrips + '","token":"' + FEED_TOKEN + '","user": "' + CLIENT_CODE + '","acctid":"' + CLIENT_CODE + '"}'; 

websocketObj.send(_req); 

 `
const AK = String.raw`
 {ak: ok, msg:mw, task:mw})
 `

const Sample = String.raw`
 [{"ak":"ok","task":"mw","msg":"mw"}]
 [{"lo":"1797.55","ts":"ACC-EQ","tp":null,"ltp":"1800.05","ltq":"27","bs":"16","tk":"22","ltt":"31\/08\/2017 11:32:01",
 "lcl":null,"tsq":"76435","cng":"-11.15","bp":"1800.00","bq":"510","mc":"34012.01277(Crs)","isdc":"18.77872
 (Crs)","name":"sf","tbq":"76497","oi":null,"yh":"1801.25","e":"nse_cm","sp":"1800.90","op":"1814.00","c": "1811.20",
 "to":"145093696.35","ut":"31-Aug-2017 11:32:01","h":"1817.55","v":"80391","nc":"- 00.62","ap":"1804.85","yl":"1800.00","ucl":null,"toi":"16654000" }]

 `
const OrderFeedReq =
    JSON.stringify({
        "actiontype": "subscribe",
        "feedtype": "order_feed",
        "jwttoken": "exysabc......",
        "clientcode": "A12345",
        "apikey": "api_key"
    }, null, 5)

const OrderFeedRes =
    JSON.stringify({
        "variety": null,
        "ordertype": "LIMIT",
        "producttype": "INTRADAY",
        "duration": "DAY",
        "price": "194",
        "triggerprice": "0",
        "quantity": "1",
        "disclosedquantity": "0",
        "squareoff": "0",
        "stoploss": "0",
        "trailingstoploss": "0",
        "tradingsymbol": "SBIN-EQ",
        "transactiontype": "BUY",
        "exchange": "NSE",
        "symboltoken": null,
        "instrumenttype": "",
        "strikeprice": "-1",
        "optiontype": "",
        "expirydate": "",
        "lotsize": "1",
        "cancelsize": "1",
        "averageprice": "0",
        "filledshares": "0",
        "unfilledshares": "1",
        "orderid": "201020000000080",
        "text": "",
        "status": "cancelled",
        "orderstatus": "cancelled",
        "updatetime": "20-Oct-2020   13:10:59",
        "exchtime": "20-Oct-2020   13:10:59",
        "exchorderupdatetime": "20-Oct-2020   13:10:59",
        "fillid": null,
        "filltime": null
    }, null, 5)


export default class Web extends Component {
    state = {
        header: 'WebSocket Streaming',
        data: [{ key: "NSE", api: 'nse_cm ' }, { key: "BSE", api: 'bse_cm ' }, { key: "NFO", api: 'nse_fo ' }, { key: "MCX", api: 'mcx_fo ' }, { key: "NCDEX", api: 'ncx_fo ' }, { key: "CDS", api: 'cde_fo ' },],
        columns: [

            {
                dataField: 'key',
                text: 'Exchange',


            },
            {
                dataField: 'api',
                text: 'Value',


            },

        ],

        taskdata: [{ key: "1", task_name: "cn", description: "To connect to websocket or to async servlet" }, { key: "2", task_name: "hb", description: "Heart beat" }, { key: "3", task_name: "mw", description: "For market watch" }, { key: "4", task_name: "sfi", description: "For subscribing index" }, { key: "5", task_name: "dp", description: "for market depth" }],
        taskcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'task_name',
                text: 'TASK NAME',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        scriptdata: [{ key: "1", param: "name", description: "sf - If value comes as sf it's a script feed" }, { key: "2", param: "tk", description: "script token" }, { key: "3", param: "e", description: "Exchange" }, { key: "4", param: "ltp", description: "Last traded price" }, { key: "5", param: "c", description: "Previous close price" }, { key: "6", param: "nc", description: "% change" }, { key: "7", param: "cng", description: "Change" }, { key: "8", param: "v", description: "Volume" }, { key: "9", param: "bq", description: "Best buy quantity" }, { key: "10", param: "bp", description: "Best buy price" }, { key: "11", param: "bs", description: "Best sell quantity " }, { key: "12", param: "sp", description: "Best sell price" }, { key: "13", param: "ltq", description: " Last traded quantity" }, { key: "14", param: "ltt", description: "Last update time" }, { key: "15", param: "ucl", description: "Upper circuit limit" }, { key: "16", param: "tbq", description: "Total buy quantity" }, { key: "17", param: "mc", description: "Market Capitalization ( issued capital * previous close)" }, { key: "18", param: "lo", description: "Low price" }, { key: "19", param: "yh", description: "Yearly high price" }, { key: "20", param: "op", description: "Open price" }, { key: "21", param: "ts", description: "Trading symbol" }, { key: "22", param: "h", description: "High price" }, { key: "23", param: "lcl", description: "Lower circuit limit" }, { key: "24", param: "tsq", description: "Total Sell quantity" }, { key: "25", param: "ap", description: "Vwap Average Price" }, { key: "26", param: "yl", description: "Yearly Low price" }, { key: "27", param: "h", description: "High price" }, { key: "28", param: "oi", description: "Open interest" }, { key: "29", param: "isdc", description: "Issued capital" }, { key: "30", param: "to", description: "Issued capital" }, { key: "31", param: "toi", description: "total open interest" }, { key: "32", param: "lter", description: "Low trade execution range" }, { key: "33", param: "hter", description: "High trade execution range" }, { key: "34", param: "setltyp", description: "Settlement type" }],
        scriptcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],
        indexdata: [{ key: "1", param: "name", description: "if - If value comes as \"if\" it's a index feed" }, { key: "2", param: "tk", description: "index token" }, { key: "3", param: "e", description: "Exchange" }, { key: "4", param: "ic", description: "index close value" }, { key: "5", param: "nc", description: "% change" }, { key: "6", param: "cng", description: "Change" }, { key: "7", param: "iv", description: "index value" }, { key: "8", param: "tvalue", description: "Update time" }, { key: "9", param: "ihv", description: "Index high value" }, { key: "10", param: "ilv", description: "Index low value" }, { key: "11", param: "iov", description: "Index open value" }],
        indexcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        heartdata: [{ key: "1", param: "ak", description: "ok/nk" }, { key: "2", param: "msg", description: "heartbeat" }, { key: "3", param: "task", description: "hb" }],
        heartcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        connectdata: [{ key: "1", param: "ak", description: "ok/nk" }, { key: "2", param: "msg", description: "connected" }, { key: "3", param: "task", description: "cn" }],
        connectcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        timedata: [{ key: "1", param: "name", description: "tm" }, { key: "2", param: "tvalue", description: "Time" }],
        timecolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        marketdata: [{ key: "1", param: "name", description: "dp" }, { key: "2", param: "bp", description: "Best Buy Price 1" }, { key: "3", param: "sp", description: "Best Sell Price 1" }, { key: "4", param: "bq", description: "Best buy quantitiy 1" }, { key: "5", param: "bs", description: " Best sell quantity 1" }, { key: "6", param: "bno", description: "Best Buy no of orders 1 " }, { key: "7", param: "sno", description: "Best Sell no of orders 1" }, { key: "8", param: "bp1", description: "Best Buy Price 2" }, { key: "9", param: "sp1", description: "Best Sell Price 2" }, { key: "10", param: "bq1", description: "Best buy quantity 2" }, { key: "11", param: "bs1", description: "Best sell quantity 2" }, { key: "12", param: "bno1", description: "Best Buy no of orders 2" }, { key: "13", param: "sno1", description: " Best Sell no of orders 2 " }, { key: "14", param: "bp2", description: "Best Buy Price 3" }, { key: "15", param: "sp2", description: "Best Sell Price 3" }, { key: "16", param: "bq2", description: "Best buy quantitiy 3" }, { key: "17", param: "bs2", description: "Best buy quantitiy 3" }, { key: "18", param: "bno2", description: "Best Buy no of orders 3" }, { key: "19", param: "sno2", description: "Best Sell no of orders 3" }, { key: "20", param: "bp3", description: "Best Buy Price 4" }, { key: "21", param: "sp3", description: " Best Sell Price 4" }, { key: "22", param: "bq3", description: "Best buy quantitiy 4" }, { key: "23", param: "bs3", description: "Best buy quantitiy 4" }, { key: "24", param: "bno3", description: "Best Buy no of orders 4" }, { key: "25", param: "sno3", description: "Best Sell no of orders 4" }, { key: "26", param: "bp4", description: "Best Buy Price 5" }, { key: "27", param: "sp4", description: "Best Sell Price 5" }, { key: "28", param: "bq4", description: "Best buy quantitiy 5 " }, { key: "29", param: "bs4", description: "Best sell quantity 5 " }, { key: "30", param: "bno4", description: "Best Buy no of orders 5 " }, { key: "31", param: "sno4", description: "Best Sell no of orders 5 " }, { key: "32", param: "tbq", description: "Total buy quantity " }, { key: "33", param: "tsq", description: "Total sell quantity " }, { key: "34", param: "lter", description: "Lower trade execution range" }, { key: "35", param: "hter", description: "High trade execution range" }],
        marketcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],
        errordata: [{ key: "1", error_code: "AG8001", description: "Invalid Token Error" }, { key: "2", error_code: "AG8002", description: "Token Expired" }, { key: "3", error_code: "AG8004", description: "Invalid API Key" }, { key: "4", error_code: "AG8005", description: "Invalid Client Code" }, { key: "5", error_code: "AG8006", description: "Authentication Credentials missing" }, { key: "6", error_code: "AG8007", description: "Required query params missing with endpoint url" }, { key: "7", error_code: "AG8008", description: "Invalid Message type" }],
        errorcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'error_code',
                text: 'Error Code',
            },
            {
                dataField: 'description',
                text: 'Description',
            }
        ],


    }
    //latest code
    componentDidMount() {
    }
    render() {
        const { header, data, columns, taskdata, taskcolumns, scriptcolumns, scriptdata, indexdata, indexcolumns, heartdata, heartcolumns, connectdata, connectcolumns, timedata, timecolumns, marketdata, marketcolumns, errordata, errorcolumns} = this.state
        return (
            <div className='container-fluid font mb-5' id="/docs/WebSocketStreaming">
                <div class="title doc-row">
                    <div class="doc-left">
                        <h1 id="response-structure">{header}</h1>
                        <p>The WebSocket API uses WebSocket protocol to establish a single long standing TCP connection after an HTTP handshake to receive streaming quotes. To connect to the SmartAPI WebSocket API, you will need a WebSocket client library in your choice of programming language. You can subscribe for instruments on a single WebSocket connection and receive live quotes for them. </p>
                        <p>To receive quotes for instruments across all exchanges during live market hours, the WebSocket API is the best to use in terms of speed, latency, resource consumption and bandwidth. A quote consists of fields such as open, high, low, close, last traded price, 5 levels of bid/offer market depth data etc. </p>
                        <p><strong style={{ fontWeight: "bolder" }}>Note:</strong> Exchange Mapping- If your exchange is ‘’NSE’’ then the value should be something like this ‘’nse_cm’’. </p>
                        <BootstrapTable

                            hover
                            keyField='id'
                            data={data}
                            columns={columns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />
                    </div>
                    {/* <div class="doc-right"></div> */}
                </div>
                <div class="title doc-row">
                    <div class="doc-left">
                        <h2>Connecting to the WebSocket endpoint </h2>
                        <p>The WebSocket URL is: </p>
                        <pre>
                            <code data-language="html">
                                wss://omnefeeds.angelbroking.com/NestHtml5Mobile/socket/stream
                                </code>
                        </pre>
                        <br />
                        <p>The WebSocket endpoint is wss:// omnefeeds.angelbroking.com. To establish a connection, you have to pass two query parameters, CLIENT_CODE and FEED_TOKEN. </p>
                        <h2>Note:-</h2>
                        <ol className="web-ol">
                            <li>There will be all input parameter sent in JSON format
                            for all type of task.</li>
                            <li>
                                To stop (unsubscribe) script feed you need to send “channel” parameter in input JSON object as blank
                                string.
                            </li>
                            <li>To stop (unsubscribe) index feed you need to send “channel” parameter in input JSON object as blank
                                string.</li>
                            <li>To start (subscribe) feed (index/script)you need to send input JSON object with “channel” value as mentioned
                                in document</li>
                            <li>Index Feed : If ampersand (&) value exists in index value , need to replace with exclamatory symbol (!). Eg : bse_cm|BSE Oil&Gas to be sent as bse_cm|BSE</li>
                            <li>Script feed : for task mw after the acknowledge response, we provide certain script details from mrv which is
                            not available in regular feed , sample is given below :<br />

                                <pre >
                                    <code data-language="javascript" >
                                        {Sample}
                                    </code>
                                </pre>

                                <br />  Where added JSONArray with each JSONObject (each sf ) holding mrv script details given in ‘channel’
                            </li>
                            <li>Even for Depth feed ( task – dp) as well as index feed ( task – sfi) , we have added first mrv data in response, where field list are same as listed under regular feed response table.</li>
                        </ol>

                        <h2>Task List</h2>
                        <BootstrapTable

                            hover
                            keyField='id'
                            data={taskdata}
                            columns={taskcolumns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />
                        <br />

                        <p>First connect to web socket using “cn” task and then subscribe script using “mw” task
                        ( Acknowledgement response : {AK}. To do reconnect to web socket we need to send task as “cn” and do the subscription
                        again. To do subscribe for index socket should be connected first.</p>
                        <br />
                        <h4>Request Structure: </h4>
                        <pre >
                            <code data-language="javascript" >
                                {WS}
                            </code>
                        </pre>
                        <h2 style={{ marginTop: '2rem' }}>Response Parameters</h2>
                        <ol>
                            <li><h4>SCRIPT FEED</h4></li>
                            <BootstrapTable

                                hover
                                keyField='id'
                                data={scriptdata}
                                columns={scriptcolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />
                            <br />
                            <p>In above table name will come for all the subscription we made such as script feed, index feed, time feed etc which is
                            not implemented as of now, for script feed name value will be “sf”. If a response doesn’t contain name parameter it can
                            be considered as acknowledgement response such as heart beat, connect. If name value comes as “if” it means it is a
                            feed for index.</p>
                            <br />
                            <li><h4>INDEX FEED</h4></li>
                            <BootstrapTable

                                hover
                                keyField='id'
                                data={indexdata}
                                columns={indexcolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />
                            <br />

                            <li><h4>HEART BEAT</h4></li>
                            <BootstrapTable

                                hover
                                keyField='id'
                                data={heartdata}
                                columns={heartcolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />
                            <br />

                            <li><h4>CONNECT</h4></li>

                            <BootstrapTable

                                hover
                                keyField='id'
                                data={connectdata}
                                columns={connectcolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />
                            <br />

                            <li><h4>TIME FEED</h4></li>

                            <BootstrapTable

                                hover
                                keyField='id'
                                data={timedata}
                                columns={timecolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />
                            <br />

                            <li><h4>MARKET DEPTH FEED</h4></li>

                            <BootstrapTable

                                hover
                                keyField='id'
                                data={marketdata}
                                columns={marketcolumns}
                                wrapperClasses={'react-bootstrap-table1'}
                                headerClasses="font"
                            />


                        </ol>
                        <div class="row">
                            <div class="col-md-6">
                                <i class=" changePrevious-Button fas fa-chevron-circle-left" title="Previous" onClick={() => changePath('/docs/Publisher')}></i>
                                {/* <input  style={{float: 'left'}} type="button" className="btn btn-primary btn-lg m-t-5" onClick={()=>changePath('/docs/Publisher')} value='<< Previous'/> */}
                            </div>
                            <div class="col-md-6">
                                <i class=" changeNext-Button fas fa-chevron-circle-right" title="Next" onClick={() => changePath('/docs/WebSocketOrderStatus')}></i>
                                {/* <input style={{float: 'right'}} type="button" className="btn btn-primary btn-lg m-t-5" onClick={()=>changePath('/docs/Instruments')} value='Next >>'/> */}
                            </div>
                        </div>

                    </div>
                    {/* <div class="doc-right"></div> */}

                </div>
            </div>
        );
    }
}
